import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import villasReducer from "./slices/villasSlice";
import projectsReducer from "./slices/projectsSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    villas: villasReducer,
    projects: projectsReducer,
  },
});
